export default __webpack_public_path__ + "static/media/Background.9dcae803.jpg";